<template>
    <div class="shopact">
        <!-- <van-nav-bar :title="data.title"/> -->
        <van-cell-group class="act">
            <van-cell title="活动名称" :value="data.title" value-class="value" />
            <van-cell title="抢购价格" :value="'¥' + data.amount" value-class="value" />
        </van-cell-group>
        <van-cell-group class="shop">
            <van-cell>
                <template slot="title">
                    <span class="label-title">门店名称</span>
                    <span class="label-content">{{ data.shop_name }}</span>
                </template>
            </van-cell>
            <van-cell>
                <template slot="title">
                    <span class="label-title">活动时间</span>
                    <span class="label-content">{{ data.begin_date }}至{{ data.end_date }}</span>
                </template>
            </van-cell>
            <van-cell>
                <template slot="title">
                    <span class="label-title">门店位置</span>
                    <span class="label-content">{{ data.shop_address }}</span>
                </template>
            </van-cell>
            <van-cell>
                <template slot="title">
                    <span class="label-title">门店电话</span>
                    <span class="label-content">{{ data.shop_phone }} {{ data.shop_contact_phone }}</span>
                </template>
            </van-cell>
        </van-cell-group>
        <van-cell-group>
            <CarNo :area_id="areashort_id" :area_name="area_name" :code="code" @pick="pickCarNo" required="true" />
            <van-field v-model="postData.phone" placeholder="联系手机" input-align="right" clearable>
                <div slot="label">
                    <span>手机号</span>(必填)
                </div>
            </van-field>
            <van-field v-model="postData.nick_name" label="昵称" placeholder="昵称" input-align="right" clearableb />
            <van-cell>
                <template slot="title">
                    <span class="label-title">备注</span>
                    <span class="label-content"><van-field v-model="postData.vip_rem" placeholder="备注信息" type="textarea" rows="3" autosize="" clearable /></span>
                </template>
            </van-cell>
        </van-cell-group>
        <van-submit-bar
            :loading="buying"
            :price="data.amount * 100"
            :disabled="disabled"
            button-text="购买"
            @submit="onBuy"
        >
            <van-goods-action-icon icon="chat-o" text="分享好友" @click="onShare" />
        </van-submit-bar>
        <ToShare ref="toshare" />
    </div>
</template>

<script>
import { 
    NavBar,
    Panel, 
    CellGroup,
    Cell,
    Field,
    Icon,
    Loading, 
    Toast,
    GoodsActionIcon,
    SubmitBar
} from 'vant'

import CarNo from '@/view/components/carno'
import { ShopActApi, ShopActItemApi } from '@/api/shopact'
import { VipApi } from '@/api/market'
import { isvalidPhone, isvalidCarCode } from '@/utils/validate'
import { payment } from '@/utils/payment'
import ToShare from '@/view/components/toshare'
// import { shareItem } from '@/utils/wxshare'
import wxshare from "@/utils/wxshare"
import { getOpenId } from '@/utils/auth'
import { getCurrentWechatUsr } from '@/utils/localutils'

// eslint-disable-next-line no-unused-vars
// import vConsole from '@/utils/vconsole'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Panel.name]: Panel,
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [Field.name]: Field,
        [Loading.name]: Loading,
        [Image.name]: Image,
        [Toast.name]: Toast,
        [Icon.name]: Icon,
        [SubmitBar.name]: SubmitBar,
        [GoodsActionIcon.name]:GoodsActionIcon,
        CarNo,
        ToShare
    },
    data() {
        return {
            data: {
                id: 0,
                shop_name: '',
                shop_area: '',
                shop_address: '',
                shop_phone: '',
                shop_contact_phone: '',
                title: null,
                package_name: '',
                create_date: '',
                begin_date: '',
                end_date: null,
                rem: null,
                note: null,
                amount: null,
                style_name: null,
                state_name: null,
                check_date: null,
                checker: null,
                checker_name: null,
                publish_date: null,
                publisher: null,
                publisher_name: null,
                package_data: {
                id: null,
                name: null,
                price: null,
                servers: [],
                versions: []
                }
            },
            postData: {
                car_code: '',
                phone: '',
                nick_name: '',
                note: '',
                shop_activity: null,
                vip_rem: '',
                openid: '',
                unionid: '',
                headimgurl: '',
                shared_id: null
            },
            areashort_id: 21,
            area_name: '粤',
            code: '',
            buying: false,
            disabled: false,
            loading: false
        }
    },
    mounted() {
        this.data.id = this.$route.params.id,
        this.postData.shop_activity = this.data.id
        console.log('活动id')
        console.log(this.postData.shop_activity)
        this.postData.shared_id = this.$route.query.shared_id
        this.getData(this.data.id)
        this.getVipInfo()
    },
    methods: {
        getData(id) {
            var that = this
            that.loading = true
            console.log('url')
            console.log(ShopActApi + id + '/')
            this.axios.get(ShopActApi + id + '/').then((ret) => {
                console.log('返回值:')
                console.log(ret)
                that.loading = false
                if (ret.flag) {
                    that.data = ret.details
                    console.log(ret)

                    const openid = getOpenId()
                    console.log(openid)
                    wxshare.shareItem(`您的好友正在分享${that.data.title}`, 
                        that.data.rem, 
                        that.data.shop_img, 
                        `${window.location.origin}/#/nt/activities/shopact/${this.data.id}/?shared_id=` + openid )
                }
            })
        },
        getVipInfo() {
            var that = this
            that.axios.get(VipApi).then((ret) => {
                console.log('huiyuanxinxi')
                console.log(ret)
                if (ret.flag) {
                    let vipCarCode = ret.details.car_code
                    that.postData.phone = ret.details.vip_phone
                    that.postData.car_code = vipCarCode
                    that.postData.nick_name = ret.details.user_name
                    if (vipCarCode.length > 0) {
                        that.area_name = vipCarCode.substring(0, 1)
                        that.code = vipCarCode.substring(1)
                    }
                } else {
                    console.log('没有关注')
                    let wxUser = getCurrentWechatUsr()
                    console.log(wxUser)
                    if (wxUser) {
                        that.postData.nick_name = wxUser.nickname
                        that.postData.openid = wxUser.openid
                        that.postData.unionid = wxUser.unionid
                        that.postData.headimgurl = wxUser.headimgurl
                    }
                }
            })
        },
        pickCarNo(item) {
            console.log(item)
            if (item != null) {
                this.areashort_id = item.area_id
                this.area_name = item.area_name
                this.code = item.code
                this.postData.car_code = this.area_name + item.code
            } else {
                this.areashort_id = 21
                this.area_name = '粤'
                this.code = ''
                this.postData.car_code = ''
            }
        },
        onShare() {
            this.$refs.toshare.show()
        },
        onBuy() {
            if (!isvalidPhone(this.postData.phone.trim())) {
                this.$toast.fail('必须输入正确的手机号码.')
                return
            }
            if (!this.postData.car_code) {
                this.$toast.fail('必须输入车牌.')
                return
            }
            if (!this.postData.car_code && !isvalidCarCode(this.postData.car_code)) {
                this.$toast.fail('必须输入正确的车牌.')
                return
            }
            if (!this.postData.nick_name) {
                this.postData.nick_name = this.postData.phone.trim()
            }
            var that = this
            that.buying = true
            that.disabled = true
            that.axios.post(ShopActItemApi , that.postData).then((ret) => {
                that.buying = false
                that.disabled = false
                // that.data = ret
                // console.log(ret)
                var amount = Number(ret.details.amount)
                if (ret.flag && amount > 0) {
                    console.log(ret)
                    let id = ret.details.id
                    payment(that, 
                        id,
                        'shopact', 
                        amount, 
                        null,
                        `/nt/activities/shopactbuyresult/${id}/`)
                }
            }).catch(function (error) {
                Toast(error)
                that.buying = false
                that.disabled = false
            })
        }
    }
}
</script>

<style lang="less">
.van-button--danger {
    margin-left: 60px;
}
</style>

<style lang="less">
.shopact {
    .act {
        .van-cell {
            background-color: #DEEBF7 !important;
        }
        .value {
            font-weight: bolder;
            color: #0066CC !important;
        }
    }
    .shop {
        .van-cell {
            background-color: #F5F5F5 !important;
        }
    }
    img {
        width: 100%;
    }
    .label-title {
        font-weight: bold;
        margin-right: 2em;
    }
    .label-content {
        
    }
    .txt {
        color: #0066CC;
        font-weight: bold;
    }

}
</style>